import { render, staticRenderFns } from "./UpdateContact.vue?vue&type=template&id=dbd54a8c&scoped=true&"
import script from "./UpdateContact.vue?vue&type=script&lang=js&"
export * from "./UpdateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd54a8c",
  null
  
)

export default component.exports